import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
function RevealBlock({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const ref = useScrollReveal<HTMLDivElement>();
  return <div ref={ref} className={`opacity-0 translate-y-10 transition-all duration-700 ease-out ${className}`} data-id="element-246">
      {children}
    </div>;
}
export function SolutionSection() {
  return <section className="bg-gris-fondo py-20 px-5" data-id="element-247">
      <div className="max-w-[760px] mx-auto" data-id="element-248">
        <RevealBlock data-id="element-249">
          <p className="text-[0.8rem] font-bold tracking-[2px] uppercase text-verde-bosque mb-3 flex items-center gap-2" data-id="element-250">
            <span className="w-6 h-0.5 bg-verde-bosque rounded-sm" data-id="element-251" />
            La solución
          </p>
        </RevealBlock>

        <RevealBlock data-id="element-252">
          <h2 className="font-display font-bold text-negro-carbon leading-[1.25] mb-6" style={{
          fontSize: 'clamp(1.6rem, 4vw, 2.4rem)'
        }} data-id="element-253">
            No necesitas más fuerza de voluntad.
            <br data-id="element-254" />
            <span className="text-verde-bosque" data-id="element-255">
              Necesitas la información correcta.
            </span>
          </h2>
        </RevealBlock>

        <RevealBlock data-id="element-256">
          <p className="text-[1.05rem] text-gray-700 leading-[1.8] mb-10" data-id="element-257">
            He reunido la ciencia del biohacking hormonal más avanzada y la he
            traducido en un protocolo práctico de 7 días para mujeres reales con
            agendas reales. Sin suplementos de $200, sin dietas restrictivas,
            sin 2 horas de gimnasio.
          </p>
        </RevealBlock>

        <RevealBlock data-id="element-258">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10" data-id="element-259">
            <BenefitCard icon="🌅" title="El Interruptor de las 8 AM" description="El error que comete el 90% de mujeres al despertar y cómo corregirlo para quemar grasa desde el primer minuto del día." data-id="element-260" />
            <BenefitCard icon="🍽️" title="La Técnica del Orden" description="El mismo plato de comida, un orden diferente. Reduce tu pico de insulina hasta un 75% sin eliminar ningún grupo alimenticio." data-id="element-261" />
            <BenefitCard icon="💊" title="El Suplemento de $10" description="El mineral que silencia los antojos de dulce a las 9 PM y activa la quema de grasa mientras duermes. No necesitas receta." data-id="element-262" />
            <BenefitCard icon="🚶‍♀️" title="Movimiento de Drenaje" description="10 minutos que bajan el azúcar en sangre más que correr 5 kilómetros. Sin elevar el cortisol. Sin equipo de gimnasio." data-id="element-263" />
            <BenefitCard icon="🧪" title="La Prueba del Espejo" description="Cómo identificar en 30 segundos si tu grasa es por cortisol o por insulina, y qué hacer diferente según tu tipo." data-id="element-264" />
            <BenefitCard icon="🌙" title="Protocolo Nocturno" description="El ritual de 3 pasos para apagar el cortisol antes de dormir y despertar desinflamada, con energía y sin antojos de azúcar." data-id="element-265" />
          </div>
        </RevealBlock>
      </div>
    </section>;
}
function BenefitCard({
  icon,
  title,
  description
}: {
  icon: string;
  title: string;
  description: string;
}) {
  return <div className="group bg-white rounded-card py-7 px-6 shadow-suave border-t-4 border-verde-bosque transition-all duration-300 relative overflow-hidden hover:-translate-y-1.5 hover:shadow-fuerte" data-id="element-266">
      {/* Gold bottom line on hover */}
      <div className="absolute bottom-0 left-0 w-0 h-[3px] bg-oro transition-all duration-400 group-hover:w-full" data-id="element-267" />
      <div className="text-[2rem] mb-3.5" data-id="element-268">{icon}</div>
      <h4 className="font-display text-[1.1rem] font-bold text-verde-bosque mb-2.5" data-id="element-269">
        {title}
      </h4>
      <p className="text-[0.9rem] text-gris-suave leading-[1.7]" data-id="element-270">
        {description}
      </p>
    </div>;
}